/* tslint:disable */

declare var Object: any;
export interface LearningCategoryInterface {
  "sfdcId"?: string;
  "OwnerId"?: string;
  "IsDeleted"?: boolean;
  "Name"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedDate"?: Date;
  "CreatedById"?: string;
  "LastModifiedDate"?: Date;
  "LastModifiedById"?: string;
  "SystemModstamp"?: Date;
  "LastActivityDate"?: Date;
  "LastViewedDate"?: Date;
  "LastReferencedDate"?: Date;
  "Background_Image_URL__c"?: string;
  "Hide_From_Catalog_Home__c"?: boolean;
  "Is_Internal__c"?: boolean;
  "Logo__c"?: string;
  "Order__c"?: number;
  "Text_Color__c"?: string;
  "Total_Training_Plans__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class LearningCategory implements LearningCategoryInterface {
  "sfdcId": string;
  "OwnerId": string;
  "IsDeleted": boolean;
  "Name": string;
  "CurrencyIsoCode": string;
  "CreatedDate": Date;
  "CreatedById": string;
  "LastModifiedDate": Date;
  "LastModifiedById": string;
  "SystemModstamp": Date;
  "LastActivityDate": Date;
  "LastViewedDate": Date;
  "LastReferencedDate": Date;
  "Background_Image_URL__c": string;
  "Hide_From_Catalog_Home__c": boolean;
  "Is_Internal__c": boolean;
  "Logo__c": string;
  "Order__c": number;
  "Text_Color__c": string;
  "Total_Training_Plans__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: LearningCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LearningCategory`.
   */
  public static getModelName() {
    return "LearningCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LearningCategory for dynamic purposes.
  **/
  public static factory(data: LearningCategoryInterface): LearningCategory{
    return new LearningCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LearningCategory',
      plural: 'LearningCategories',
      path: 'LearningCategories',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "SystemModstamp": {
          name: 'SystemModstamp',
          type: 'Date'
        },
        "LastActivityDate": {
          name: 'LastActivityDate',
          type: 'Date'
        },
        "LastViewedDate": {
          name: 'LastViewedDate',
          type: 'Date'
        },
        "LastReferencedDate": {
          name: 'LastReferencedDate',
          type: 'Date'
        },
        "Background_Image_URL__c": {
          name: 'Background_Image_URL__c',
          type: 'string'
        },
        "Hide_From_Catalog_Home__c": {
          name: 'Hide_From_Catalog_Home__c',
          type: 'boolean'
        },
        "Is_Internal__c": {
          name: 'Is_Internal__c',
          type: 'boolean'
        },
        "Logo__c": {
          name: 'Logo__c',
          type: 'string'
        },
        "Order__c": {
          name: 'Order__c',
          type: 'number'
        },
        "Text_Color__c": {
          name: 'Text_Color__c',
          type: 'string'
        },
        "Total_Training_Plans__c": {
          name: 'Total_Training_Plans__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
